class SiteHeader {
	constructor(el) {
		this.el = el;
		this.headerHeight = 0;

		this.updateHeaderHeightVar();
		this.setupEventHandlers();
	}

	setupEventHandlers() {
		// mobile menu button handler
		const btnMobileMenu = this.el.querySelector('.site-header__mobile-menu-button');

		if (btnMobileMenu) {
			btnMobileMenu.addEventListener('click', () => {
				document.documentElement.classList.toggle('mobile-menu-active');
			});
		}

		// desktop menu hover state handler
		const menuItemWithMega = this.el.querySelectorAll('.menu-item-has-mega');

		menuItemWithMega.forEach(m => {
			const subMenu = m.querySelector('.mega-menu__section');

			m.addEventListener('mouseover', () => {
				if (subMenu) {
					document.documentElement.classList.toggle('desktop-menu-active');
					subMenu.classList.toggle('active');
					m.classList.toggle('active');
				}
			});
			
			m.addEventListener('mouseout', () => {
				if (subMenu) {
					document.documentElement.classList.toggle('desktop-menu-active');
					subMenu.classList.toggle('active');
					m.classList.toggle('active');
				}
			});
		});

		// update header height on resize
		window.addEventListener('resize', () => this.updateHeaderHeightVar());

		// update header height on scroll
		window.addEventListener('scroll', () => this.updateHeaderHeightVar());
	}

	updateHeaderHeightVar() {
		this.headerHeight = this.el.offsetHeight;
		
	}
}

export default SiteHeader;
